module.exports = __webpack_public_path__ + "img/banner-dex-safe.f1cb90c4.webp";